module.exports = __webpack_public_path__ + "static/img/qi.9afba13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/qi.png
// module id = b7Qt
// module chunks = 1